const timeArray = [
  "1 minute",
  "2 minutes",
  "5 minutes",
  "10 minutes",
  "15 minutes",
  "20 minutes",
  "30 minutes",
  "45 minutes",
  "1 hrs",
  "1.30 hrs",
  "2 hrs",
  "2.30 hrs",
  "3.00 hrs",
];

export default timeArray;
